import { Timer, Zap, MessageSquare, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
  [Timer, "Deadlines up front", "Every listing shows how soon the seller needs to move it, so buyers know where the deals are."],
  [Zap, "Built for speed", "Listing is quick and simple. Less form-filling, more selling."],
  [MessageSquare, "Serious buyers only", "Urgent listings attract people ready to act, not window shoppers."],
  [ShieldCheck, "Safety first", "[Add your trust & safety features here, such as verification or reporting tools.]"],
];

export const WhyUs = () => (
  <section id="why" className="relative border-t border-white/[0.08] bg-[#0D0E13]" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 lg:py-36 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-5 lg:sticky lg:top-28 self-start">
        <Eyebrow>Why urgent</Eyebrow>
        <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
          Life moves fast. <span className="text-[#FFB800]">Your listings should too.</span>
        </h2>
        <p className="mt-6 max-w-md text-zinc-400 leading-relaxed">
          Moving city, upgrading, clearing space or just needing cash this week. UrgentSellBuy is made for the moments when waiting isn't an option.
        </p>
      </Reveal>
      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
        {ITEMS.map(([Icon, t, d], i) => (
          <Reveal key={t} delay={i * 0.08}>
            <div className="group h-full rounded-3xl border border-white/10 bg-[#12141C] p-8 transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-[#FF3838]/40" data-testid={`why-card-${i + 1}`}>
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#FF3838]/10 text-[#FF3838] transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-8 font-display text-xl font-semibold tracking-tight">{t}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
